import React, { useState } from "react";
import "./SignUp.css";
import { FaGoogle } from "react-icons/fa";
import {
  signInWithPopup,
  GoogleAuthProvider,
  createUserWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import TopNavbar from "../Nav/TopNavbar";

const SignUp = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const googleLogin = async () => {
    setLoading(true);
    setError("");
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const emailSignUp = async () => {
    if (!name || !email || !password) {
      setError("All fields are required!");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      await updateProfile(auth.currentUser, { displayName: name });
      console.log("User created:", userCredential.user);
      navigate("/login");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TopNavbar />
      <div className="bg">
        <div className="signup">
          <div className="signup-connect">
            <h1 style={{ color: "#7620FF" }}>Login with Google</h1>
            <button
              className="btn btn-google"
              onClick={googleLogin}
              disabled={loading}
            >
              <FaGoogle style={{ marginRight: "10px" }} />{" "}
              {loading ? "Processing..." : "Sign in with Google"}
            </button>
          </div>
          <div className="signup-classic" style={{ color: "black" }}>
            <h2 style={{ fontWeight: "600", fontSize: "25px" }}>
              Create Your Account
            </h2>
            {error && <p className="error-message">{error}</p>}
            <div className="form" style={{ color: "black" }}>
              <fieldset className="username">
                <input
                  type="text"
                  style={{ color: "black" }}
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  disabled={loading}
                />
              </fieldset>
              <fieldset className="email">
                <input
                  type="email"
                  style={{ color: "black" }}
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
              </fieldset>
              <fieldset className="password">
                <input
                  type="password"
                  style={{ color: "black" }}
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </fieldset>
              <button className="btn" onClick={emailSignUp} disabled={loading}>
                {loading ? "Creating Account..." : "Sign Up"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignUp;
